import { DEFAULT_PAGINATION } from 'core/constants/pagination.constants';
import { IYapePromotionListParams } from 'core/model/interfaces/yape/yape.interface';
import { apiService } from 'core/services';
import type { TSliceExtraReducer } from 'core/store';
import { createAppAsyncThunk } from 'core/store/store.helpers';
import { removeEmptyValues } from 'shared/utils/object.utils';
import { SLICE_NAMESPACE } from '../constants';
import type { IYapeState } from '../types';

export const fetchYapePromotionList = createAppAsyncThunk(
  `${SLICE_NAMESPACE}/fetchYapePromotionList`,
  async (params: IYapePromotionListParams, { getState }) => {
    const { yape } = getState();
    return apiService.yape.getYapePromotionList(
      removeEmptyValues({
        ...params,
        page: yape.promo.list.pagination.currentPage,
      }),
    );
  },
);

export const fetchYapePromotionListReducer: TSliceExtraReducer<IYapeState> = builder =>
  builder
    .addCase(fetchYapePromotionList.pending, state => {
      state.promo.list.isLoading = true;
    })
    .addCase(fetchYapePromotionList.rejected, state => {
      state.promo.list.isLoading = false;
      state.promo.list.pagination = DEFAULT_PAGINATION;
      state.promo.list.data = [];
    })
    .addCase(fetchYapePromotionList.fulfilled, (state, { payload }) => {
      state.promo.list.data = payload.yapePromotions;
      state.promo.list.pagination = payload.pagination;
      state.promo.list.isLoading = false;
    });
